import styled from 'styled-components'

export default styled.header`
`



// WEBPACK FOOTER //
// ./src/components/HeaderSidebarLayout/Header.js